import parse_pdf from "workflow/actions/parse_pdf"

export default (...args) =>
    parse_pdf(...args)
        .next()
        .then(({ value }) => value)
